<div class="modal-content document-viewer-modal">
  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    @if (currentImage) {
      <div class="document-container">
        <img [src]="currentImage.image_url" [alt]="currentImage.image_name" class="document-image">
      </div>

      <div class="document-info">
        <span class="document-name">{{ currentImage.image_name }}</span>
        @if (images.length > 1) {
          <span class="document-counter">{{ currentIndex + 1 }} / {{ images.length }}</span>
        }
      </div>
    } @else {
      <div class="no-documents">
        <i class="fa fa-image fs-1 text-muted mb-3"></i>
        <p class="text-muted">{{ 'images.noImages' | translate }}</p>
      </div>
    }
  </div>

  @if (images.length > 1) {
    <div class="modal-footer justify-content-between">
      <button type="button" class="btn btn-light" (click)="previous()" [disabled]="currentIndex === 0">
        <i class="fa fa-chevron-left me-2"></i>
        {{ 'common.previous' | translate }}
      </button>
      <button type="button" class="btn btn-light" (click)="next()" [disabled]="currentIndex === images.length - 1">
        {{ 'common.next' | translate }}
        <i class="fa fa-chevron-right ms-2"></i>
      </button>
    </div>
  }
</div>
